<template>
    <div>
        <slot :turnstileId="turnstileId" :turnstileToken="turnstileToken" />
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useId } from "@/composables/useId";
import { waitForTurnstile } from "@/services/turnstile";

export default defineComponent({
    name: "auth-register",
    setup() {
        const turnstileId = useId();
        const turnstileToken = ref("");

        let widgetId: string | null = null;

        onMounted(async () => {
            await waitForTurnstile();

            widgetId = globalThis.turnstile.render(`#${turnstileId}`, {
                sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
                size: "flexible",
                callback: function (token: string) {
                    turnstileToken.value = token;
                },
            });
        });

        return {
            turnstileId,
            turnstileToken,
            widgetId,
        };
    },
});
</script>
